import {
  collection,
  selection,
  composeReducers,
} from 'common/store/reducer';

import { DEVICES_FILTER_BY_TAG, REMOVE_DEVICES_FILTER_BY_TAG } from "./actions";

import {
  NAMESPACE,
} from './actions';

const initial = {
  ...collection.defaultSort(''), //default sort 'deviceId' is not required for /devices page due to API slowness
};

const devicesFilterByTag = (state, action) => {
  return{
    ...state,
    filterTag: action.tag,
  }
}

const removeDevicesFilterByTag = (state) => {
  return{
    ...state,
    filterTag: undefined,
  }
}

const collectionReducer = (state = initial, action) => {
  const reducer = {
    [DEVICES_FILTER_BY_TAG]: devicesFilterByTag,
    [REMOVE_DEVICES_FILTER_BY_TAG]: removeDevicesFilterByTag,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};

export default composeReducers(
  collection.factory(NAMESPACE),
  selection.factory(NAMESPACE),
  collectionReducer,
  (state = initial) => state,
);
